module.exports = "/static/assets/1a88d4b4c95e4f7675f834e35bd09333.png";